import { render, staticRenderFns } from "./CtaCard.vue?vue&type=template&id=4451d5b2&scoped=true&"
import script from "./CtaCard.vue?vue&type=script&lang=ts&"
export * from "./CtaCard.vue?vue&type=script&lang=ts&"
import style0 from "./CtaCard.vue?vue&type=style&index=0&id=4451d5b2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4451d5b2",
  null
  
)

export default component.exports